<template>
  <v-container fluid>
    <v-card class="mt-2">
      <v-card-title>
        <v-btn @click="siteDialog = true; selectedKey = null; selectedCustomer = {id: null}" color="primary">Add Site</v-btn>
        <v-spacer></v-spacer>
          <v-switch
            v-model="onlyHeadOffice"
            label="Only Head Offices"
            color="primary"
            hide-details
          ></v-switch>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table :headers="headers" :items="filteredSites" :search="search" :pagination.sync="pagination">
        <template slot="items" slot-scope="props">
          <tr @click.stop="selectedKey = props.item.key; siteDialog = true; selectedCustomer = {id: props.item.Customer}">
            <td>{{ props.item.customerName }}<v-chip small color="red" text-color="white" v-if="props.item.headOffice">{{'Head Office'}}</v-chip></td>
            <td>{{ props.item.Name }}</td>
            <td>{{ props.item.Town }}</td>
            <td>{{ props.item.PostCode }}</td>
            <td>
              <v-btn icon class="mx-0" @click.stop="deleteSite(props.item)">
                <v-icon color="pink">delete</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
    <site-edit-dialog @getSites="getSites" @setCustomer="updateCustomer" :customer="selectedCustomer" :customers="customers" :siteDialog.sync="siteDialog" :siteID="selectedKey"></site-edit-dialog>
  </v-container>
</template>

<script>
import { updateAuditLog, fireStore } from '../firebase'
// import moment from 'moment'
export default {
  data () {
    return {
      customers: {},
      sites: [],
      search: '',
      onlyHeadOffice: false,
      pagination: {
        sortBy: 'customerName',
        rowsPerPage: 25,
        page: 1,
        descending: false
      },
      selectedCustomer: null,
      selectedKey: null,
      siteDialog: false,
      headers: [
        {
          text: 'Customer',
          value: 'customerName'
        },
        {
          text: 'Name',
          value: 'Name'
        },
        {
          text: 'Town',
          value: 'Town'
        },
        {
          text: 'PostCode',
          value: 'PostCode'
        }
      ]
    }
  },
  created () {
    this.getCustomers()
    this.getSites()
    console.log(this.$route.fullPath)
  },
  methods: {
    getCustomers () {
      fireStore.collection('Customers').get()
      .then(snap => {
        snap.forEach(doc => {
          this.customers[doc.id] = {customerName: doc.data().customerName, headOffice: doc.data().headOffice}
        })
      })
    },
    getSites () {
      this.sites = []
      fireStore.collection('Sites').get()
      .then(snap => {
        snap.forEach(doc => {
          this.sites.push({...doc.data(), key: doc.id})
        })
      })
    },
    updateCustomer (customerObj) {
      this.customers[customerObj.customer].headOffice = customerObj.headOffice
      this.$forceUpdate()
    },
    deleteSite (item) {
      confirm('Are you sure you want to delete this item?') && fireStore.collection('Sites').doc(item.key).delete().then(() => {
        updateAuditLog('delete', 'sites', this.user, null, null, 'deleted site', item, item.Customer)
        this.getSites()
      })
    }
  },
  computed: {
    user () {
      return this.$store.getters.userData
    },
    filteredSites () {
      let filteredSites = []
      for (let site in this.sites) {
        let thisSite = JSON.parse(JSON.stringify(this.sites[site]))
        if (this.customers[thisSite.Customer] !== undefined) {
          thisSite.headOffice = this.customers[thisSite.Customer].headOffice == thisSite.key
          thisSite.customerName = this.customers[thisSite.Customer].customerName
          if (this.onlyHeadOffice && thisSite.headOffice) {
            filteredSites.push(thisSite)
          } else if (!this.onlyHeadOffice) {
            filteredSites.push(thisSite)
          }
        }
      }
      return filteredSites
    }
  }
}
</script>


// WEBPACK FOOTER //
// Sites.vue?154cb07e